import noUiSlider from "nouislider";

export default function(Alpine) {
    Alpine.directive("multi-range-slider", (el, directive, { evaluate }) => {
        if (!directive.value) {
            handleRoot(el, Alpine, evaluate(directive.expression));
        } else if (directive.value === "input") {
            handleInput(el, Alpine);
        }
    }).before("bind");
}

function handleRoot(el, Alpine, settings) {
    settings = settings || {};

    Alpine.bind(el, {
        "@reset.window"(e) {
            const parentEl = this.$el.closest("form[x-data]");

            if (!parentEl || e.target !== parentEl) {
                return;
            }

            this.reset();
        },
        "x-data"() {
            return {
                $slider: null,
                step: 100,
                min: null,
                max: null,
                minStart: null,
                maxStart: null,

                init() {
                    const numberFormatter = new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    });

                    this.step = Number(this.$el.dataset.step) || this.step;

                    this.$nextTick(() => {
                        this.min = Number(this.$el.dataset.min);
                        this.max = Number(this.$el.dataset.max);

                        const startValues = [Number(this.$el.dataset.minStart || this.min), Number(this.$el.dataset.maxStart || this.max)];

                        this.$slider = noUiSlider.create(this.$refs.slider, {
                            start: startValues,
                            connect: true,
                            step: this.step,
                            range: {
                                min: this.min,
                                max: this.max
                            },
                            format: {
                                to: (value) => {
                                    return Number(value);
                                },
                                from: (value) => {
                                    return Number(value);
                                }
                            },
                            ...settings,
                        });

                        if (this.$refs.min || this.$refs.max) {
                            this.$slider.on("update", (values, handle) => {
                                const value = values[handle];

                                if (handle === 0 && this.$refs.min) {
                                    this.$refs.min.value = value;
                                } else if (handle === 1 && this.$refs.max) {
                                    this.$refs.max.value = value;
                                }
                            });

                            // This makes sure a change event is triggered when the slider values have changed
                            // so it can bubble up as a form change event for the parent component to know
                            // when filters have changed and trigger an update.
                            this.$slider.on("change", (value, handle) => {
                                const changeEvent = new Event("change", {
                                    bubbles: true
                                });

                                if (handle === 0 && this.$refs.min) {
                                    this.$refs.min.dispatchEvent(changeEvent);
                                } else if (handle === 1 && this.$refs.max) {
                                    this.$refs.max.dispatchEvent(changeEvent);
                                }
                            });
                        }
                    });
                },

                reset() {
                    this.$slider.reset();
                },
            };
        }
    });
}

function handleInput(el, Alpine) {
    Alpine.bind(el, {
        ":step": "step",
        ":min": "min",
        ":max": "max",
        "@input.debounce.400ms"() {
            this.$slider.set([this.$refs.min.value, this.$refs.max.value], false);
        }
    });
}

function handleTooltip(el, Alpine) {

}
